import { useEffect, useRef } from "react";
import { getCurrencySymbolCrypto } from "../../../helper/GetCurrencySymbolCrypto";

function AdvancedChartWidget({ activeAccount, theme }) {
  const container = useRef();

  useEffect(() => {
    if (!activeAccount || !container.current || !theme) return;

    const timeout = setTimeout(() => {
      // Clear old content
      container.current.innerHTML = "";

      const symbol = getCurrencySymbolCrypto(activeAccount.currency_code);

      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
      script.type = "text/javascript";
      script.async = true;
      script.onerror = (e) => {
        console.error("TradingView script load error:", e);
      };

      script.innerHTML = `
        {
          "allow_symbol_change": false,
          "calendar": false,
          "details": false,
          "hide_side_toolbar": true,
          "hide_top_toolbar": false,
          "hide_legend": false,
          "hide_volume": false,
          "interval": "D",
          "locale": "en",
          "symbol": "${symbol}",
          "theme": "${theme}",
          "autosize": true,
          "show_popup_button": true,
          "popup_height": "650",
          "popup_width": "1000"
        }
      `;

      // Append the script if still mounted
      if (container.current) {
        container.current.appendChild(script);
      }
    }, 0);

    return () => clearTimeout(timeout); // Clean up
  }, [activeAccount, theme]);

  return (
    <div className="w-full">
      <div
        className="overflow-hidden rounded-sm shadow-box-shadow border border-background-surface"
        ref={container}
        style={{ height: "500px" }}
      >
        <div className="tradingview-widget-container__widget" />
      </div>
    </div>
  );
}

export default AdvancedChartWidget;
